<template>
  <div>

    <div class="row">
      <div class="col-sm-6">
        <h4 qid="do-list-page-title" class="float-left">
          {{ $t('risk_matrix.title') }}
        </h4>
        <div class="mt-2 ml-3 float-left">
        </div>
      </div>
      <div class="col-sm-6 text-right">
        <button class="btn btn-secondary-dark float-right ml-3 pl-3 pr-3" @click="filterOpened = !filterOpened">
          <font-awesome-icon icon="filter"/>
        </button>
      </div>
    </div>
    <div class="row" :class="{'table-with-filters': filterOpened}">
      <div class="col-sm-10 table-container">
        <div class="card row">
          <div class="row ml-0 mr-0">
            <div class="col-md-1 mr-0 pr-0 pl-0 ml-0 " style="writing-mode: tb-rl;transform: rotate(180deg);
  text-align: center;width:40px;max-width: 40px;">
              <div style="height: 96%;" class="mt-0 mr-0 mb-5 pt-5 pr-3">
                <div style="border-right: 1px solid black;"></div>
                <h5 class="title-crossed title-crossed-vertical">
                  <span>{{ $t('activities.risk_scenario.current_risk.table.impact') }}</span>
                </h5>
              </div>
            </div>
            <div class="col-md-11 pr-3 pt-3 pl-0">
              <table class="table table-bordered matrix">
                <tbody>
                  <tr class="d-flex">
                    <td class="col-3">
                      <span class="badge matrix-4 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('Very high', 'Very unlikely', 'Medium risk')" v-if="risks['41']">
                        {{ this.risks['41']}}
                      </span>
                    </td>
                    <td class="col-3">
                      <span class="badge matrix-8 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('Very high', 'Unlikely', 'High risk')" v-if="risks['42']">
                        {{ this.risks['42']}}
                      </span>
                    </td>
                    <td class="col-3 bold-left">
                      <span class="badge matrix-12 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('Very high', 'Likely', 'Very high risk')" v-if="risks['43']">
                        {{ this.risks['43']}}
                      </span>
                    </td>
                    <td class="col-3">
                      <span class="badge matrix-16 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('Very high', 'Very likely', 'Very high risk')" v-if="risks['44']">
                        {{ this.risks['44']}}
                      </span>
                    </td>
                  </tr>
                  <tr class="d-flex">
                    <td class="col-3 bold-bottom">
                      <span class="badge matrix-3 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('High', 'Very unlikely', 'Medium risk')" v-if="risks['31']">
                        {{ this.risks['31']}}
                      </span>
                    </td>
                    <td class="col-3 bold-bottom">
                      <span class="badge matrix-6 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('High', 'Unlikely', 'High risk')" v-if="risks['32']">
                        {{ this.risks['32']}}
                      </span>
                    </td>
                    <td class="col-3 bold-bottom bold-left">
                      <span class="badge matrix-9 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('High', 'Likely', 'High risk')" v-if="risks['33']">
                        {{ this.risks['33']}}
                      </span>
                    </td>
                    <td class="col-3 bold-bottom">
                      <span class="badge matrix-12 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('High', 'Very likely', 'Very high risk')" v-if="risks['34']">
                        {{ this.risks['34']}}
                      </span>
                    </td>
                  </tr>
                  <tr class="d-flex">
                    <td class="col-3">
                      <span class="badge matrix-2 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('Low', 'Very unlikely', 'Low risk')" v-if="risks['21']">
                        {{ this.risks['21']}}
                      </span>
                    </td>
                    <td class="col-3">
                      <span class="badge matrix-4 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('Low', 'Unlikely', 'Medium risk')" v-if="risks['22']">
                        {{ this.risks['22']}}
                      </span>
                    </td>
                    <td class="col-3 bold-left">
                      <span class="badge matrix-6 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('Low', 'Likely', 'High risk')" v-if="risks['23']">
                        {{ this.risks['23']}}
                      </span>
                    </td>
                    <td class="col-3">
                      <span class="badge matrix-8 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('Low', 'Very likely', 'High risk')" v-if="risks['24']">
                        {{ this.risks['24']}}
                      </span>
                    </td>
                  </tr>
                  <tr class="d-flex">
                    <td class="col-3">
                      <span class="badge matrix-1 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('Very low', 'Very unlikely', 'Low risk')" v-if="risks['11']">
                        {{ this.risks['11']}}
                      </span>
                    </td>
                    <td class="col-3">
                      <span class="badge matrix-2 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('Very low', 'Unlikely', 'Low risk')" v-if="risks['12']">
                        {{ this.risks['12']}}
                      </span>
                    </td>
                    <td class="col-3 bold-left">
                      <span class="badge matrix-3 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('Very low', 'Likely', 'Medium risk')" v-if="risks['13']">
                        {{ this.risks['13']}}
                      </span>
                    </td>
                    <td class="col-3">
                      <span class="badge matrix-4 m-3 pl-5 pr-5 cursor-pointer" @click="openViewRiskListModal('Very low', 'Very likely', 'Medium risk')" v-if="risks['14']">
                        {{ this.risks['14']}}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="text-center mt-3 h5">
                <h5 class="title-crossed title-crossed-horisontal" style="margin-top: 25px;">
                  <span>{{ $t('activities.risk_scenario.current_risk.table.probability') }}</span>
                </h5>
              </div>
            </div>
          </div>
          <div class="m-4 text-center">
            <span class="m-2">
              <font-awesome-icon
                      icon="exclamation-triangle"
                      :class="'risk-1'"
              />
              {{ $t('risk.low_risk') }}
            </span>
            <span class="m-2">
              <font-awesome-icon
                      icon="exclamation-triangle"
                      :class="'risk-3'"
              />
              {{ $t('risk.medium_risk') }}
            </span>

            <span class="m-2">
              <font-awesome-icon
                      icon="exclamation-triangle"
                      :class="'risk-9'"
              />
              {{ $t('risk.high_risk') }}
            </span>
            <span class=" m-2">
              <font-awesome-icon
                      icon="exclamation-triangle"
                      :class="'risk-16'"
              />
              {{ $t('risk.very_high_risk') }}
            </span>

          </div>
        </div>
      </div>
      <div class="col-sm-2 filter-container" >
        <div class="card">
          <div class="card-body">
            <b-alert v-if="filters.error && filters.error.length"
                     show
                     variant="danger"
                     qid="edit-user-error"
            >
              {{ filters.error }}
            </b-alert>

            <b-form-group>
              <label qid="filter-do-classification-label">
                {{ $t('risk_scenarios.dashboard.risk_area.title') }} <span class="align-top">*</span>
              </label>
              <multiselect
                  v-model="filters.area"
                  :options="areaItems"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  :placeholder="$t('risk_scenarios.dashboard.risk_area.placeholder')"
                  label="name"
                  :allow-empty="false"
                  @select="debounceInput"
                  @remove="debounceInput"
                  qid="filter-do-form-classification"
                  track-by="value"
              ></multiselect>
            </b-form-group>
            <b-form-group>
              <label qid="filter-do-category-label">
                {{ $t('risk_scenarios.dashboard.risk_type.title') }} <span class="align-top">*</span>
              </label>
              <multiselect
                  v-model="filters.type"
                  :options="typeItems"
                  :placeholder="$t('risk_scenarios.dashboard.risk_type.placeholder')"
                  label="name"
                  :allow-empty="false"
                  @select="debounceInput"
                  @remove="debounceInput"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  qid="filter-do-form-category"
                  track-by="value"
              ></multiselect>
            </b-form-group>
            <b-form-group>
              <label qid="filter-do-category-label">
                {{ $t('risk_scenarios.dashboard.risk_scope.title') }} <span class="align-top">*</span>
              </label>
              <multiselect
                  v-model="filters.scope"
                  :options="scopeItems"
                  :placeholder="$t('risk_scenarios.dashboard.risk_scope.placeholder')"
                  label="name"
                  :allow-empty="false"
                  @select="debounceInput"
                  @remove="debounceInput"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  qid="filter-do-form-category"
                  track-by="value"
              ></multiselect>
            </b-form-group>
            <b-form-group v-if="getClient.risk_type == 'cia_risk'">
              <label qid="filter-do-category-label">
                {{ $t('risk_scenarios.dashboard.cia_type.title') }} <span class="align-top">*</span>
              </label>
              <multiselect
                  v-model="filters.cia_type"
                  :options="ciaTypeItems"
                  :placeholder="$t('risk_scenarios.dashboard.cia_type.placeholder')"
                  label="name"
                  :allow-empty="false"
                  @select="debounceInput"
                  @remove="debounceInput"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  qid="filter-do-form-type"
                  track-by="value"
              ></multiselect>
            </b-form-group>
            <a href="#" @click="resetFilters" class="text-right" qid="do-filters-reset">
              {{ $t('system.reset_filters') }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <ViewRiskListModal
        :showModal="showViewRiskListModal"
        :filters="filters"
        :impact="selectedImpact"
        :probability="selectedProbability"
        :risk="selectedRisk"
        @closeViewModal="handleCloseViewRiskListModal"
    ></ViewRiskListModal>

  </div>
</template>

<script>

import piincHttp from '@/util/configureAxios.js';
import ViewRiskListModal from '@/views/Dashboard/ViewRiskListModal.vue';

export default {
  name: 'MaintenanceDashboard',
  data: function() {
    return {
      areaItems: [
        { name: this.$t('risk_scenarios.dashboard.risk_area.business_risk'), value: "business" },
        { name: this.$t('risk_scenarios.dashboard.risk_area.privacy_risk'), value: "privacy" },
      ],
      typeItems: [
        { name: this.$t('risk_scenarios.dashboard.risk_type.current_risk'), value: "current" },
        { name: this.$t('risk_scenarios.dashboard.risk_type.inherent_risk'), value: "inherent" },
      ],
      ciaTypeItems: [
        { name: this.$t('validations.checklist.confidentiality'), value: "confidentiality" },
        { name: this.$t('validations.checklist.integrity'), value: "integrity" },
        { name: this.$t('validations.checklist.availability'), value: "availability" }
      ],
      scopeItems: [
        { name: this.$t('risk_scenarios.dashboard.risk_scope.process'), value: "process" },
        { name: this.$t('risk_scenarios.dashboard.risk_scope.activity'), value: "activity" },
        { name: this.$t('risk_scenarios.dashboard.risk_scope.system'), value: "system" },
        { name: this.$t('risk_scenarios.dashboard.risk_scope.third_party'), value: "third_party" },
      ],
      filters: {
        area: { name: this.$t('risk_scenarios.dashboard.risk_area.business_risk'), value: "business" },
        type: { name: this.$t('risk_scenarios.dashboard.risk_type.current_risk'), value: "current" },
        scope: { name: this.$t('risk_scenarios.dashboard.risk_scope.process'), value: "process" },
        error: ''
      },
      filterOpened: true,
      risks: [],
      riskData: [],
      showViewRiskListModal: false,
      selectedImpact: '',
      selectedProbability: '',
      selectedRisk: '',
    }
  },
  components: {
    ViewRiskListModal
  },
  computed: {
    getClient() {
      return this.$store.state.client
    }
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function () {
      this.loadContent()
    }
  },
  methods: {
    debounceInput: _.debounce(function() {
      this.loadContent()
    }, 400),
    openViewRiskListModal(impact, probability, risk) {
      this.selectedImpact = impact;
      this.selectedProbability = probability;
      this.selectedRisk = risk;
      this.showViewRiskListModal = true

    },
    handleCloseViewRiskListModal () {
      this.selectedImpact = '';
      this.selectedProbability = '';
      this.selectedRisk = '';
      this.showViewRiskListModal = false;
    },
    loadContent() {

      let self = this;
      // Load Policies Data
      piincHttp.get('risk-scenarios/statistics', { params:
        {
          client: this.getClient.slug,
          area: this.filters.area ? this.filters.area.value : undefined,
          type: this.filters.type ? this.filters.type.value : undefined,
          cia_risk_type: this.filters.cia_type ? this.filters.cia_type.value : undefined,
          scope: this.filters.scope ? this.filters.scope.value : undefined,
        }
      }).then(function(response) {
        self.risks = response.data;
        self.filters.error = '';
      }, function(error) {
        if (error.status == 400) {
          self.risks = [];
          self.filters.error = error.data.message;
        }
      })
    },
    resetFilters() {
      this.filters.type = '',
      this.filters.cia_type = '',
      this.filters.area = '',
      this.filters.scope = '',
      this.debounceInput()
    },
  },
  created () {
    if (this.getClient && this.getClient.slug) {
      this.loadContent();
    }
  }
}
</script>
